import * as React from "react";
const EyeIcon = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5075_58747)">
      <path
        d="M0.666016 8.0013C0.666016 8.0013 3.33268 2.66797 7.99935 2.66797C12.666 2.66797 15.3327 8.0013 15.3327 8.0013C15.3327 8.0013 12.666 13.3346 7.99935 13.3346C3.33268 13.3346 0.666016 8.0013 0.666016 8.0013Z"
        stroke="white"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99935 10.0013C9.10392 10.0013 9.99935 9.10587 9.99935 8.0013C9.99935 6.89673 9.10392 6.0013 7.99935 6.0013C6.89478 6.0013 5.99935 6.89673 5.99935 8.0013C5.99935 9.10587 6.89478 10.0013 7.99935 10.0013Z"
        stroke="white"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5075_58747">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default EyeIcon;
